var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramVideoIcon({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: 18,
    viewBox: "0 0 48 48",
    width: 18,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 46.5c-1 0-2-.3-2.9-.8-1.8-1.1-2.9-2.9-2.9-5.1V7.3c0-2.1 1.1-4 2.9-5.1 1.9-1.1 4.1-1.1 5.9 0l30.1 17.6c1.5.9 2.3 2.4 2.3 4.1 0 1.7-.9 3.2-2.3 4.1L12.6 45.7c-.9.5-2 .8-3 .8z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiBoZWlnaHQ9IjE4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSIxOCI+PHBhdGggZD0iTTkuNiA0Ni41Yy0xIDAtMi0uMy0yLjktLjgtMS44LTEuMS0yLjktMi45LTIuOS01LjFWNy4zYzAtMi4xIDEuMS00IDIuOS01LjEgMS45LTEuMSA0LjEtMS4xIDUuOSAwbDMwLjEgMTcuNmMxLjUuOSAyLjMgMi40IDIuMyA0LjEgMCAxLjctLjkgMy4yLTIuMyA0LjFMMTIuNiA0NS43Yy0uOS41LTIgLjgtMyAuOHoiPjwvcGF0aD48L3N2Zz4K";
export { SvgInstagramVideoIcon as ReactComponent };